/** The 19 jury score values: 1, 1.5, 2, … 9.5, 10. */
export const SCORE_VALUES: readonly number[] = Array.from({ length: 19 }, (_, i) => 1 + i * 0.5);

export const SCORE_MIN = 1;
export const SCORE_MAX = 10;
export const SCORE_STEP = 0.5;
/** Neutral midpoint; also the "no votes" item score. */
export const SCORE_MID = 5.5;

/** Tile index (0…18) → score value. Out-of-range indexes are clamped. */
export function indexToScore(index: number): number {
  const i = Math.min(18, Math.max(0, Math.round(index)));
  return 1 + i * 0.5;
}

/** Score value → nearest tile index (0…18). */
export function scoreToIndex(score: number): number {
  return Math.min(18, Math.max(0, Math.round((score - 1) * 2)));
}

/** Snap any number to the nearest legal score. */
export function snapScore(score: number): number {
  return indexToScore(scoreToIndex(score));
}

function hexToRgb(hex: string): [number, number, number] {
  const n = parseInt(hex.slice(1), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

function mix(a: string, b: string, t: number): string {
  const [r1, g1, b1] = hexToRgb(a);
  const [r2, g2, b2] = hexToRgb(b);
  const c = (x: number, y: number) => Math.round(x + (y - x) * t);
  return `rgb(${c(r1, r2)} ${c(g1, g2)} ${c(b1, b2)})`;
}

const RED = '#ff4d2e';
const YELLOW = '#ffde00';
const GREEN = '#22c55e';

/** Fill colour of a tile: red (1) → yellow (5.5) → green (10). */
export function tileColor(index: number): string {
  const i = Math.min(18, Math.max(0, index));
  return i <= 9 ? mix(RED, YELLOW, i / 9) : mix(YELLOW, GREEN, (i - 9) / 9);
}

/**
 * Text colour for `tileColor(index)`. Ink everywhere: it clears 4.5:1 on the whole red→yellow→green
 * ramp, whereas white drops to ~2.3:1 on the greens and ~3:1 on the reds.
 */
export function tileTextColor(index: number): string {
  void index;
  return '#111111';
}

/** Reaction face for a score (shown on the big badge). */
export function scoreFace(score: number): string {
  if (score <= 2) return '🤮';
  if (score <= 3.5) return '😖';
  if (score <= 5) return '😕';
  if (score <= 6.5) return '😐';
  if (score <= 8) return '😋';
  if (score <= 9.5) return '🤩';
  return '👑';
}
